import React from "react";

// Stopgap until the board is made responsive: on small screens, show a
// dismissable banner recommending desktop play. Dismissal is remembered.
const DISMISS_KEY = "pp_small_screen_dismissed";
const QUERY = "(max-width: 768px)";

const matchesSmall = (): boolean =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(QUERY).matches;

export const SmallScreenNotice = (): JSX.Element | null => {
  const [small, setSmall] = React.useState<boolean>(matchesSmall);
  const [dismissed, setDismissed] = React.useState<boolean>(
    () => localStorage.getItem(DISMISS_KEY) === "1"
  );

  React.useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(QUERY);
    const onChange = (e: MediaQueryListEvent) => setSmall(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  if (!small || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div className="small-screen-notice" role="alert">
      <span className="small-screen-notice-text">
        Heads up: Poker Solitaire isn’t optimized for small screens yet. For the
        best experience, we recommend playing on a desktop browser.
      </span>
      <button
        className="small-screen-notice-close"
        onClick={dismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};
